import { render, staticRenderFns } from "./ProductHierarchySelect.vue?vue&type=template&id=47d1ced2&"
import script from "./ProductHierarchySelect.vue?vue&type=script&lang=js&"
export * from "./ProductHierarchySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports